/*
 * @Author: huangzq
 * @Date: 2019-12-31 15:13:56
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-06 23:53:33
 * @Desc: 高级设置
*/
<template>
  <div class="high-set">
    <mk-form
      :model="materialData"
      label-position="top"
    >
      <mk-form-item label="作品标签设置">
        <div class="rules-set">
          <tag-rules
            v-model="materialData.rules"
            :rules-data="materialData"
            type="h5"
          />
        </div>
      </mk-form-item>
    </mk-form>
  </div>
</template>

<script>
import TagRules from '@components/tag-rules'
export default {
  name: 'HighSet',
  components: { TagRules },
  props: {
    materialData: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.high-set {
  & /deep/ .el-form-item__label {
    padding-bottom: 0;
    line-height: normal;
  }
}
</style>
